module.exports = __webpack_public_path__ + "static/media/page-04.a18a3fa2.png";